import { Routes } from "@angular/router";
import { shareUrlsByType } from "globals/store/share.data";
import { ShareQuoteComponent } from "./modules/share/share-quote.component";
import { ShareEventInformationComponent } from "./modules/event-information/share-event-information.component";
import { ShareRevenueComponent } from "./modules/share/share-revenue.component";
import { PerformerSubmitComponent } from "./modules/share/share.submitPerformer";
import { ResourceSubmitComponent } from "./modules/share/share.submitResource.component";
import { ExhibitorSubmitComponent } from "./modules/share/share.submitExhibitor.component";
import { AttendeeSubmitComponent } from "./modules/share/share.submitAttendee.component";
import { PerformerEditComponent } from "./modules/share/share.editPerformer";
import { ShareResourceComponent } from "./modules/share/share-resource.component";
import { ShareLogisticsComponent } from "./modules/share/share-logistics.component";
import { ShareAttendeesComponent } from "./modules/share/share-attendees-view.component";
import { SponsorEditComponent } from "./modules/share/share.editSponsor";
import { ShareOSSPageComponent } from "./modules/share/share.oss.page";
import { ShareNewAssetComponent } from "./modules/share/share-new-asset";
import { ShareAssociatedAssetsComponent } from "./modules/share/share-associated-assets.component";
import { ShareStagingRequestComponent } from "./modules/share/share.stagingRequest";
import { ShareExhibitorRequestComponent } from "./modules/share/share.exhibitorRequest";
import { ShareSessionSynopsisComponent } from "./modules/share/share.sessionSynopsis";
import { ShareBriefComponent } from "./modules/share/share.brief";
import { AttendeeEditComponent } from "./modules/share/share.editAttendee.component";
import { ExhibitorEditComponent } from "./modules/share/share.editExhibitor.component";
import { ShareEventListsComponent } from "./modules/share/share.event-lists.component";
import { ShareNotesComponent } from "./modules/share/share.notes.component";
import { SharePageComponent } from "./modules/share/share.page";
import { CueSheetShareComponent } from "./modules/cues/cue-sheet-share.component";

export const routes: Routes = [
  { path: `${shareUrlsByType.quote}/:id`, component: ShareQuoteComponent },
  { path: `${shareUrlsByType.information}/:id`, component: ShareEventInformationComponent },
  { path: `${shareUrlsByType.revenue}/:eventId/:revenueId`, component: ShareRevenueComponent },
  { path: `${shareUrlsByType.submitPerformers}/:eventId/:templateId`, component: PerformerSubmitComponent },
  { path: `${shareUrlsByType.submitResources}/:eventId/:templateId`, component: ResourceSubmitComponent },
  { path: `${shareUrlsByType.submitExhibitors}/:eventId/:templateId`, component: ExhibitorSubmitComponent },
  { path: `${shareUrlsByType.submitAttendees}/:eventId/:templateId`, component: AttendeeSubmitComponent },
  { path: 'profile/:publishCode', component: PerformerEditComponent},
  { path: `${shareUrlsByType.profile}/:publishCode`, component: PerformerEditComponent},
  { path: `${shareUrlsByType.resource}/:publishCode`, component: ShareResourceComponent},
  { path: `${shareUrlsByType.logistics}/:publishCode`, component: ShareLogisticsComponent},
  { path: `${shareUrlsByType.attendeesView}/:publishCode`, component: ShareAttendeesComponent},
  { path: 'sponsor/:publishCode', component: SponsorEditComponent},
  { path: `${shareUrlsByType.sponsor}/:publishCode`, component: SponsorEditComponent},
  { path: 'oss/:id', component: ShareOSSPageComponent},
  { path: `${shareUrlsByType.oss}/:id`, component: ShareOSSPageComponent},
  { path: 'asset/:eventId/:id', component: ShareNewAssetComponent},
  { path: `${shareUrlsByType.entityAsset}/:id`, component: ShareAssociatedAssetsComponent},
  { path: 'staging-request/:id', component: ShareStagingRequestComponent},
  { path: `${shareUrlsByType.stagingRequest}/:id`, component: ShareStagingRequestComponent},
  { path: `${shareUrlsByType.eRequest}/:id`, component: ShareExhibitorRequestComponent},
  
  { path: 'synopsis/:id', component: ShareSessionSynopsisComponent },
  { path: `${shareUrlsByType.synopsis}/:id`, component: ShareSessionSynopsisComponent },
  { path: 'performer/:id', component: ShareBriefComponent},
  { path: `${shareUrlsByType.performer}/:id`, component: ShareBriefComponent},
  { path: 'brief/:id', component: ShareBriefComponent },
  { path: `${shareUrlsByType.exhibitorBrief}/:id`, component: ShareBriefComponent },
  { path: `${shareUrlsByType.resourceBrief}/:id`, component: ShareBriefComponent },
  { path: `${shareUrlsByType.attendeeBrief}/:id`, component: ShareBriefComponent },
  { path: 'exhibitor/:publishCode', component: ExhibitorEditComponent },
  { path: `${shareUrlsByType.attendee}/:publishCode`, component: AttendeeEditComponent },
  { path: `${shareUrlsByType.exhibitor}/:publishCode`, component: ExhibitorEditComponent },
  { path: 'events/:publishCode', component: ShareEventListsComponent },
  { path: `${shareUrlsByType.events}/:publishCode`, component: ShareEventListsComponent },
  { path: `${shareUrlsByType.notes}/:publishCode`, component: ShareNotesComponent },
  { path: ':publishCode', component: SharePageComponent },
  { path: `${shareUrlsByType.publish}/:publishCode`, component: SharePageComponent },
  { path: `${shareUrlsByType.cues}/:publishCode`, component: CueSheetShareComponent },
  { path: '*', component: SharePageComponent },
  
];